import type { ReactNode } from 'react'
import { View } from 'react-native'

import { TEST_ID } from '@/src/general/constants/testId'

import { ExistingConversation } from './components/ExistingConversation'
import { NewConversation } from './components/NewConversation'
import { NoSelectedConversation } from './components/NoSelectedConversation'

export const MessagesScreen = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const conversationId = Number(searchParams.conversationId) || undefined
  const openedConversationId = Number(searchParams.openedConversationId) || undefined
  const userId = Number(searchParams.userId) || undefined

  return (
    <View testID={TEST_ID.MESSAGES.SCREEN} className="flex-1">
      {conversationId && (
        <ExistingConversation conversationId={conversationId} openedConversationId={openedConversationId} />
      )}
      {userId && !conversationId && <NewConversation userId={userId} conversationId={conversationId} />}
      {!conversationId && !userId && (
        <NoSelectedConversation conversationId={conversationId} openedConversationId={openedConversationId} />
      )}
    </View>
  )
}
